import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

/**
 * Records a visit on every route change (skipped for /admin* routes).
 * De-duplicates within a 15-second window per path.
 */
export default function AnalyticsTracker() {
  const location = useLocation();
  const lastRef = useRef({ path: "", at: 0 });

  useEffect(() => {
    const path = location.pathname + (location.search || "");
    if (path.startsWith("/admin")) return;
    const now = Date.now();
    if (lastRef.current.path === path && now - lastRef.current.at < 15000) return;
    lastRef.current = { path, at: now };
    api
      .post("/analytics/visit", {
        path,
        referrer: document.referrer || "",
      })
      .catch(() => {});
  }, [location.pathname, location.search]);

  return null;
}
